module.exports = __webpack_public_path__ + "img/orca.f3d998ed.svg";